var $45f88f0321bb5a8f$exports = {};
$45f88f0321bb5a8f$exports = {
    "help": `Aiuto`,
    "info": `Informazioni`
};


export {$45f88f0321bb5a8f$exports as default};
//# sourceMappingURL=it-IT.module.js.map
